export default __webpack_public_path__ + "static/SR France - Radiation and Ionisation - Statement-85d14f414e2a6395d3753af6338cdd68.pdf";